
import './AppCheckBox.css'
import { useState } from 'react';
const AppCheckBox=({ data, handleChange,handleChangeUni, handleNext, count })=>{
  const [val1, setVal1] = useState(data.characterfloral);
  const [val2, setVal2] = useState(data.characterfruity);
  const [val3, setVal3] = useState(data.characternutty);
  const [val4, setVal4] = useState(data.characterberry);
  const [val5, setVal5] = useState(data.charactercoca);
  const [val6, setVal6] = useState(data.characterdriedfruit);
  const [val7, setVal7] = useState(data.characterbrownspice);
  const [val8, setVal8] = useState(data.charactertropical);
  const [val9, setVal9] = useState(data.characterherbal);
  const [val10, setVal10] = useState(data.characterstoneFruit);
  const [val11, setVal11] = useState(data.characteroverripe);
  const [val12, setVal12] = useState(data.charactercitric);
  const [generalCharacter, setGeneralCharacter] = useState([]);


  function onChangeValueGeneralCharacter(event) {
    // setUnifromVal(event.target.value);
     const cleanV = [...generalCharacter];
    const index = cleanV.indexOf(event.target.value);
    if (index === -1) {
      cleanV.push(event.target.value);
    } else {
      cleanV.splice(index, 1);
    }
    setGeneralCharacter(cleanV);
    const ev={
      value:cleanV,
      name:"generalcharacter"
    }
    console.log(ev);
    // handleChangeUni({target:ev});
  }

  function onChangeValue1(event) {
    setVal1(!val1);
    console.log(event.target.value);
    handleChange(event)
  }
  function onChangeValue2(event) {
    setVal2(!val2);
    console.log(event.target.value);
    handleChange(event)
  }
  function onChangeValue3(event) {
    setVal3(!val3);
    console.log(event.target.value);
    handleChange(event)
  }
  function onChangeValue4(event) {
    setVal4(!val4);
    console.log(event.target.value);
    handleChange(event)
  }
  function onChangeValue5(event) {
    setVal5(!val5);
    console.log(event.target.value);
    handleChange(event)
  }
  function onChangeValue6(event) {
    setVal6(!val6);
    console.log(event.target.value);
    handleChange(event)
  }
  function onChangeValue7(event) {
    setVal7(!val7);
    console.log(event.target.value);
    handleChange(event)
  }
  function onChangeValue8(event) {
    setVal8(!val8);
    console.log(event.target.value);
    handleChange(event)
  }
  function onChangeValue9(event) {
    setVal9(!val9);
    console.log(event.target.value);
    handleChange(event)
  }
  function onChangeValue10(event) {
    setVal10(!val10);
     handleChange(event)
    console.log(event.target.value);
  }

  function onChangeValue11(event) {
    setVal11(!val11);
    console.log(event.target.value);
    handleChange(event)
  }
  function onChangeValue12(event) {
    setVal12(!val12);
    console.log(event.target.value);
    handleChange(event)
  }

    return(
    <div className='appcheckflex'  onChange={onChangeValueGeneralCharacter}>
        {/* data.characterFloral==false?false:val1  */}
     <div onChange={onChangeValue1}>
      <input class='appCheckInput' id={`floralF-${count}`} type="checkbox" name="characterfloral" value={val1} onChange={handleChange} checked={'' + data.characterfloral==="true"} />
      <label className='appCheckLabel' for={`floralF-${count}`}>Floral</label>
     </div>

     <div onChange={onChangeValue2}>
     <input class='appCheckInput' id={`fruityF-${count}`} type="checkbox" name="characterfruity" value={val2} onChange={handleChange} checked={'' + data.characterfruity==="true" }  />
     <label className='appCheckLabel' for={`fruityF-${count}`}>Fruity</label>
     
     </div>
     
    
     <div onChange={onChangeValue3}>
     <input class='appCheckInput' id={`nuttyF-${count}`} type="checkbox" name="characternutty" value={val3} onChange={handleChange}  checked={'' + data.characternutty==="true" }  />
     <label className='appCheckLabel' for={`nuttyF-${count}`}>Nutty</label>
     <br/>
     </div>
     

     <div onChange={onChangeValue4}>
     <input class='appCheckInput' id={`berryF-${count}`} type="checkbox" name="characterberry" value={val4} onChange={handleChange} checked={'' + data.characterberry==="true" }  />
     <label className='appCheckLabel' for={`berryF-${count}`}>Berry</label>
     </div>

        <div onChange={onChangeValue5}>
        <input class='appCheckInput' id={`cocoaF-${count}`} type="checkbox" name="charactercoca" value={val5} onChange={handleChange} checked={'' + data.charactercoca==="true" }  />
        <label className='appCheckLabel' for={`cocoaF-${count}`}>Cocoa</label>
        </div>

      <div onChange={onChangeValue6}>
      <input class='appCheckInput' id={`driedfruitF-${count}`} type="checkbox" name="characterdriedfruit" value={val6} onChange={handleChange} checked={'' + data.characterdriedfruit==="true" } />
      <label  className='appCheckLabel' for={`driedfruitF-${count}`}>Dried fruit</label>
      <br/>
      </div>

      <div onChange={onChangeValue7}>
      <input class='appCheckInput' id={`brownspiceF-${count}`} type="checkbox" name="characterbrownspice"  value={val7} onChange={handleChange} checked={'' + data.characterbrownspice==="true"} />
     <label className='appCheckLabel' for={`brownspiceF-${count}`}>Brownspice</label>
     
      </div>
      
      <div onChange={onChangeValue8}>
      <input class='appCheckInput' id={`tropicalF-${count}`} type="checkbox" name="charactertropical" value={val8} onChange={handleChange} checked={'' + data.charactertropical==="true"}  />
      <label className='appCheckLabel' for={`tropicalF-${count}`}>Tropical</label>

      </div>

      <div onChange={onChangeValue9}> 
      <input class='appCheckInput' id={`herbalF-${count}`} type="checkbox" name="characterherbal" value={val9} onChange={handleChange} checked={'' + data.characterherbal==="true" }  />
      <label className='appCheckLabel' for={`herbalF-${count}`}>Herbal</label>
      <br/>
      </div>

      <div onChange={onChangeValue10}>
      <input class='appCheckInput' id={`stonefruitF-${count}`} type="checkbox" name="characterstonefruit" value={val10} onChange={handleChange} checked={'' + data.characterstonefruit==="true" }  />
       <label className='appCheckLabel' for={`stonefruitF-${count}`}>Stonefruit</label>
    
      </div>

      <div onChange={onChangeValue11}>
      <input  class='appCheckInput'id={`fermentyF-${count}`} type="checkbox" name="characteroverripe" value={val11} onChange={handleChange} checked={'' + data.characteroverripe==="true" } />
      <label className='appCheckLabel' for={`fermentyF-${count}`}>Overripe</label>
     
      </div>

      <div onChange={onChangeValue12}>
      <input class='appCheckInput' id={`citricF-${count}`} type="checkbox" name="charactercitric" value={val12} onChange={handleChange} checked={'' + data.charactercitric==="true" } />
      <label className='appCheckLabel' for={`citricF-${count}`}>Citric</label>
      </div>

     </div> 
    );
}
export default AppCheckBox;